define('views/blocks/checkout/PaymentModeSelectionModalView',['underscore', 'backbone', 'jquery', 'router', 'app', 'SubView',
    'views/blocks/paymentModeProviders/OgoneIFrameView',
    'views/blocks/paymentModeProviders/OgoneDirectIFrameView',
    'views/blocks/paymentModeProviders/OgoneBrandsView',
    'views/blocks/paymentModeProviders/CVCView',
    'views/blocks/paymentModeProviders/CashOnDeliveryView',
    'views/blocks/paymentModeProviders/EdenredProviderView',
    'views/blocks/InvoiceAddressSelectorView',
    'template!blocks/checkout/payment-mode-selection-modal',
    'views/blocks/paymentModeProviders/OgoneDirectBrandsView',

], function (_, Backbone, $, router, app, SubView,
             OgoneIFrameView,
             OgoneDirectIFrameView,
             OgoneBrandsView,
             CVCView,
             CashOnDeliveryView,
             EdenredProviderView,
             InvoiceAddressSelectorView,
             templateModal,
             OgoneDirectBrandsView
     ){
    var checkoutModel,
        initialPaymentMode,
        initialOptions,
        selectedPaymentMode;

    var PROVIDER_REQUIRE_RETURN_MONEY = 1;
    var PROVIDER_REQUIRE_OGONE_ADD_CARD = 20;
    var PROVIDER_REQUIRE_OGONE_CVC = 21;
    var PROVIDER_REQUIRE_OGONE_BRAND = 22;
    var PROVIDE_REQUIRE_OGONE_DIRECT_IFRAME = 23;
    var PROVIDER_REQUIRE_PRIMARY_ADDRESS = 30;
    var PROVIDER_REQUIRE_OGONE_DIRECT_FORM = 50;
    var PROVIDER_REQUIRE_OGONE_DIRECT_BRAND = 52;
    return Backbone.View.extend(SubView).extend({
        className:'payment-mode__selection__modal',
        overlay:'translucent',
        events:{
            'click .btn-close':'abort',
            'click .btn-back':'stepBack',
            'click .payment-mode__selection__item':'onClickLabelSelection',
            'click .payment-mode__selection__delete':'onClickDeleteItem',
            'change [name="payment-mode-selection"]':'onChangeRadioSelection',
            'click html,body':'onClickOut',
            'keypress html,body':'onEchap',
        },
        initialize:function(options){
            var view = this,
                displayMessage = false,
                group = options.group || 0,
                requirement = options.requirement || 0,
                displayMainList = group === 0 && requirement <= 0,
                account = view.account = !options.checkoutModel;
            view.autoSubmit = !!options.autoSubmit;
            view.subviews = [];
            if(!account){
                checkoutModel = options.checkoutModel;
                initialPaymentMode = checkoutModel.getUsedPaymentMode();
                if(checkoutModel.getPaymentGroups(0).getPaymentModes().size()===0){
                    displayMessage = app.t('Aucun mode de paiement disponible','Checkout');
                }
                if(requirement === -1){
                    view.autoSubmit = true;
                }
            }
            initialOptions = initialPaymentMode ? _.clone(initialPaymentMode.getOptions()) : {};
            view.$el.html(templateModal({
                displayMainList:displayMainList,
                displayMessage:displayMessage,
                group:group,
            }));
            if(group === 1){
                // groupe ticket restaurant
                view.addEdenred();
            }else if(!displayMainList){
                view.displayRequirement(requirement,options.paymentMode);
            }
        },
        onClickLabelSelection:function(e){
            var radio = $(':radio',e.currentTarget).get(0);
            if(e.originalEvent.target !== radio && radio.checked){
                this.selectRadio(radio);
            }
        },
        onClickDeleteItem:function(e){
            var view = this,
                button = view.$(e.currentTarget),
                radio = button.siblings(':radio'),
                params = radio.data('params'),
                id_card = params.id_card;
            var line = button.parents('.payment-mode__selection__line');
            var label = button.parents('.payment-mode__selection__label');
            function remove(){
                button.addClass('loading').attr('disabled',true);
                label.addClass('disabled');
                app.getCustomer().removeCard(id_card).done(function(){
                    line.slideUp(function(){
                        line.remove();
                    })
                })
            }
            app.confirm({
                title:app.t('Attention','UI'),
                subtitle:app.t('Voulez-vous supprimer définitivement de cette carte ?','Checkout')
            },function(confirm){
                if(confirm) remove();
                line.animate({scrollLeft:0},250);
            })

            return false;

        },
        onChangeRadioSelection:function(e) {
            var radio = e.currentTarget;
            this.selectRadio(radio);
        },
        selectRadio:function(radio){
            var view = this,
                $radio = view.$(radio),
                id_payment_mode = $radio.data('id_payment_mode'),
                params = $radio.data('params'),
            paymentMode = checkoutModel.getPaymentMode(id_payment_mode);
            paymentMode.resetOptions(params,true);
            selectedPaymentMode = paymentMode;
            var requirement = paymentMode.getRequirement();
            view.displayRequirement(requirement,paymentMode)
        },
        displayRequirement:function(requirement,paymentMode){
            var paymentModeProviderView,
                view = this,
                viewOptions = {
                paymentMode:paymentMode,
                checkoutModel:view.account?null:checkoutModel
            };

            switch(requirement){
                case PROVIDER_REQUIRE_OGONE_CVC :
                    //
                    paymentModeProviderView = new CVCView(viewOptions);
                    break;
                case PROVIDE_REQUIRE_OGONE_DIRECT_IFRAME:
                    paymentModeProviderView = new OgoneDirectIFrameView(viewOptions);
                    break;
                case PROVIDER_REQUIRE_OGONE_BRAND :
                    //
                    paymentModeProviderView = new OgoneBrandsView(viewOptions);
                    break;
                case PROVIDER_REQUIRE_OGONE_ADD_CARD :
                    //
                    if(paymentMode.get("provider") === "OgoneDirectProvider"){
                        paymentModeProviderView = new OgoneDirectIFrameView(viewOptions);
                    }else{
                        paymentModeProviderView = new OgoneIFrameView(viewOptions);
                    }
                    break;
                case PROVIDER_REQUIRE_RETURN_MONEY :
                    // le champs monnaie à prévoir est uniquement en VAD
                    paymentModeProviderView = new CashOnDeliveryView(viewOptions);
                    break;
                case PROVIDER_REQUIRE_PRIMARY_ADDRESS :
                    paymentModeProviderView = new InvoiceAddressSelectorView({});
                    checkoutModel.usePaymentMode(paymentMode);
                    view.close();
                    app.displayModal(paymentModeProviderView);
                    return;
                    break;
            }
            console.log('requirement',requirement);
            if(paymentModeProviderView){
                view.listenTo(paymentModeProviderView,'close',function(){
                   var newRequirement = paymentMode.getRequirement();
                    console.log("close paymentModeProviderView" , newRequirement, paymentMode);
                   view.displayRequirement(newRequirement,paymentMode);
                });
                view.$('.payment-mode__selection__modal__board').hide();
                view.$('.payment-mode__selection__modal__board-navigator').append(paymentModeProviderView.$el);
                view.$('.btn-back').show();
                view.attachView(paymentModeProviderView);
            }else{
                if(!view.account){
                    checkoutModel.usePaymentMode(paymentMode);
                }
                app.trigger('changePaymentModeParams',paymentMode);
                view.close();
                if(view.autoSubmit){
                    checkoutModel.submitCheckout();
                }
            }

        },
        addEdenred:function(){
            var view = this,
                edenredIFrameView = new EdenredProviderView();
            view.$('.payment-mode__selection__modal__board-navigator').append(edenredIFrameView.$el);
            view.attachView(edenredIFrameView);
            view.listenTo(edenredIFrameView,'close',view.close);
            view.$('.btn-back').hide();
        },
        stepBack:function(){
            var view = this;
            view.$('.payment-mode__selection__modal__board:visible').remove();
            view.$('.payment-mode__selection__modal__board:last').show();
            view.$('.btn-back').toggle(view.$('.payment-mode__selection__modal__board').length>1);
            if(view.$('.payment-mode__selection__modal__board:visible').length === 0){
                view.close();
            }
        },
        abort:function(){
            if(initialPaymentMode && initialOptions){
                initialPaymentMode.set('options',initialOptions);
            }
            this.close();
        },
        close:function(){
            this.trigger('close',this);
        },
        onClickOut:function(e){
        },
        onEchap:function(e){
        }
    });
});

